// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CareerList,
    CareerListFromJSON,
    CareerListToJSON,
} from './';

/**
 * 
 * @export
 * @interface CareerListPaginated
 */
export interface CareerListPaginated {
    /**
     * 
     * @type {number}
     * @memberof CareerListPaginated
     */
    next?: number;
    /**
     * 
     * @type {number}
     * @memberof CareerListPaginated
     */
    previous?: number;
    /**
     * 
     * @type {number}
     * @memberof CareerListPaginated
     */
    count: number;
    /**
     * 
     * @type {Array<CareerList>}
     * @memberof CareerListPaginated
     */
    results: Array<CareerList>;
}

export function CareerListPaginatedFromJSON(json: any): CareerListPaginated {
    return {
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'count': json['count'],
        'results': (json['results'] as Array<any>).map(CareerListFromJSON),
    };
}

export function CareerListPaginatedToJSON(value?: CareerListPaginated): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'next': value.next,
        'previous': value.previous,
        'count': value.count,
        'results': (value.results as Array<any>).map(CareerListToJSON),
    };
}


